/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Private_Chats_Enable_Confirm_ReversibleInputs */



/**
* | output |
* | --- |
* | "You can turn this off at any time; every member then sees all chats again." |
*
* @param {Project_Private_Chats_Enable_Confirm_ReversibleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_private_chats_enable_confirm_reversible = /** @type {((inputs?: Project_Private_Chats_Enable_Confirm_ReversibleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Private_Chats_Enable_Confirm_ReversibleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Sie können das jederzeit wieder ausschalten; dann sehen alle Mitglieder wieder alle Chats.")
	return /** @type {LocalizedString} */ ("You can turn this off at any time; every member then sees all chats again.")
});